module.exports = __webpack_public_path__ + "static/media/mask2.ebc00553.svg";